import { Avatar, AvatarGroup, ThemeOptions, Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { lightTokens } from 'wisestep-base';

import { RecruiterAvatarSurplus } from './RecruiterAvatarSurplus';

const avatarSize = 28;

export const RecruiterAvatarGroup = ({ list }) => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={() => createTheme(lightTokens as ThemeOptions)}>
      <AvatarGroup max={4} sx={{ maxWidth: '10.5rem', justifyContent: 'flex-end' }}>
        {list?.map((item, index) => {
          const surplus = index === 3 && list.length > 4;
          const name = item.name;
          const props = { ...stringAvatar(item.name, index) };
          props.sx['width'] = avatarSize;
          props.sx['height'] = avatarSize;
          props.sx['fontSize'] = avatarSize / 2;
          if (item.url) {
            props.sx['cursor'] = 'pointer';
            props['onClick'] = () => navigate(item.url);
          }
          return (
            index <= 3 &&
            (surplus ? (
              <RecruiterAvatarSurplus list={list} {...props} skip={3} />
            ) : (
              <Tooltip title={item.name}>
                <Avatar {...props}>
                  {name
                    .split(' ')
                    .filter((e, i) => i < 2)
                    .map((w) => w?.[0]?.toUpperCase() ?? '')
                    .join('')}
                </Avatar>
              </Tooltip>
            ))
          );
        })}
      </AvatarGroup>
    </ThemeProvider>
  );
};

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    const lightValue = Math.min(255, value + 100);
    color += `00${lightValue.toString(16)}`.slice(-2);
  }

  return color;
}

export const stringAvatar = (name: string, index?: number) => {
  return {
    sx: {
      bgcolor:
        index !== undefined
          ? ['#F6EBD0', '#FDC9D0', '#BBF2EF', '#CAF0F8'][index]
          : stringToColor(name),
      color: 'common.black',
    },
  };
};
